import moment from 'moment'
import isEqual from 'lodash/isEqual'
import { timeZoneOffset } from 'legacy/common/dateUtils'
import {
  type DayOfWeekOption,
  RepeatShiftEnum,
} from 'domains/shifts/components/recurring-shifts/recurringShift.types'
import {
  addInterval,
  detectOverlap,
  type IntervalType,
} from 'domains/shifts/components/utils/intervalUtils'

export function calculateActualStoreHours(warehouseEarlyHours, regularHours, actualHours) {
  const warehouseEarlyHourSet = Boolean(warehouseEarlyHours && warehouseEarlyHours.earlyHour)
  const zoneOffset = timeZoneOffset(regularHours.start)
  const regularStoreOpen = moment(regularHours.start).utc()
  const regularStoreClose = moment(regularHours.end).utc()

  // TODO: In case there is a location that is missing logistics delivery hours
  // (aka "actual" hours), default to using the Regular Hours for now
  // Note that if a custom "early hour" is set for the warehouse, we ignore the "actualStoreOpen"
  const actualStoreOpen =
    !warehouseEarlyHourSet && actualHours
      ? moment(regularHours.start)
          .utc()
          .hours(actualHours.startsAtHour + zoneOffset * -1)
      : regularStoreOpen
  const actualStoreClose = actualHours
    ? moment(regularHours.start)
        .utc()
        .hours(actualHours.endsAtHour + zoneOffset * -1)
    : regularStoreClose

  return {
    actualStoreOpen: actualStoreOpen.toDate(),
    actualStoreClose: actualStoreClose.toDate(),
    regularStoreOpen: regularStoreOpen.toDate(),
    regularStoreClose: regularStoreClose.toDate(),
  }
}

export const getRepeatTypeFromDaysOfWeek = (daysOfWeek: DayOfWeekOption[]): RepeatShiftEnum => {
  // TO-DO - add tests
  const EVERY_WEEKDAY = [1, 2, 3, 4, 5],
    DAILY = [0, 1, 2, 3, 4, 5, 6]
  if (!daysOfWeek || daysOfWeek.length == 0 || daysOfWeek.length > 7) {
    return RepeatShiftEnum.DoesNotRepeat
  }
  if (daysOfWeek.length == 1) {
    return RepeatShiftEnum.WeeklyOnDay
  }
  if (isEqual(daysOfWeek.map(d => d.value).sort(), EVERY_WEEKDAY)) {
    return RepeatShiftEnum.EveryWeekday
  }
  if (isEqual(daysOfWeek.map(d => d.value).sort(), DAILY)) {
    return RepeatShiftEnum.Daily
  }
  return RepeatShiftEnum.Custom
}

type StoreHoursType = {
  regularStoreOpen: Date
  actualStoreOpen: Date
  actualStoreClose: Date
}
export const isStoreClosed = (currentColumnIndex: number, storeHours: StoreHoursType): boolean => {
  const { regularStoreOpen, actualStoreOpen, actualStoreClose } = storeHours
  const storeOpenTime = new Date(regularStoreOpen.getTime())
  const startTimeOfCurrentInterval = addInterval(storeOpenTime, currentColumnIndex)

  if (
    startTimeOfCurrentInterval < actualStoreOpen ||
    startTimeOfCurrentInterval >= actualStoreClose
  ) {
    return true
  }

  return false
}

export const cellIsCurrentInterval = (
  currentColumnIndex: number,
  regularStoreOpen: Date
): boolean => {
  const currentColumnStartTime = addInterval(regularStoreOpen, currentColumnIndex)
  const currentColumnEndTime = addInterval(regularStoreOpen, currentColumnIndex + 1)
  const nowTime = new Date()

  return currentColumnStartTime <= nowTime && nowTime < currentColumnEndTime
}

export const isShopperAvailable = (
  shopperShifts: IntervalType[],
  targetShift: IntervalType
): boolean => {
  const doesOverlap = shopperShifts?.some(shopperShift => detectOverlap(shopperShift, targetShift))

  return !(doesOverlap ?? true)
}
